import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/globals.css';
import '@livekit/components-styles/index.css';
import { App } from '@/app/App';
import { useAuthStore } from '@/stores/authStore';

async function enableMocks(): Promise<void> {
  if (import.meta.env.VITE_ENABLE_MSW !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

useAuthStore.getState().rehydrate();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

void enableMocks().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
